import { render, staticRenderFns } from "./ImpactsStatisticWidget.vue?vue&type=template&id=f810f052&scoped=true&"
import script from "./ImpactsStatisticWidget.vue?vue&type=script&lang=ts&"
export * from "./ImpactsStatisticWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f810f052",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VContainer,VRow,VSkeletonLoader})
